import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react'

interface TourLifecycle {
  isTourActive: boolean
  beginTour: () => () => void
}

const TourLifecycleContext = createContext<TourLifecycle | undefined>(undefined)

export function TourLifecycleProvider({ children }: { children: ReactNode }) {
  const [activeTourCount, setActiveTourCount] = useState(0)

  const beginTour = useCallback(() => {
    let completed = false
    setActiveTourCount((count) => count + 1)

    return () => {
      if (completed) return
      completed = true
      setActiveTourCount((count) => Math.max(0, count - 1))
    }
  }, [])

  const value = useMemo(
    () => ({ isTourActive: activeTourCount > 0, beginTour }),
    [activeTourCount, beginTour]
  )

  return <TourLifecycleContext.Provider value={value}>{children}</TourLifecycleContext.Provider>
}

export function useTourLifecycle() {
  const context = useContext(TourLifecycleContext)
  if (!context) {
    throw new Error('useTourLifecycle must be used within TourLifecycleProvider')
  }
  return context
}
